import { Action } from "@ngrx/store";

import { SearchHint } from "../../data/model";
import { SearchState } from "./state";
import * as Actions from "./actions";

export function searchReducer(
    state: SearchState = new SearchState(),
    action: Actions.Actions,
) {
    switch (action.type) {
        case Actions.Update.type:
            return Object.assign({}, state, {
                hint: Object.assign({}, state.hint, {
                    [action.key]: action.value,
                }),
            });

        case Actions.SetExtended.type:
            const hint: SearchHint = state.hint;
            if (!action.value) {
                const hint = Object.assign({}, state.hint, {
                    FirstName: state.hint.FirstName,
                    LastName: state.hint.LastName,
                    EMail: state.hint.EMail,
                    OfferExternalId: state.hint.OfferExternalId,
                });
            }
            return Object.assign({}, state, {
                hint: hint,
                extended: action.value,
            });

        case Actions.Reset.type:
            return new SearchState();

        default:
            return state;
    }
}
